import { render, staticRenderFns } from "./DeleteButton.vue?vue&type=template&id=49168c5a&scoped=true&"
import script from "./DeleteButton.vue?vue&type=script&lang=ts&"
export * from "./DeleteButton.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteButton.vue?vue&type=style&index=0&id=49168c5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49168c5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
